<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div>
    <list-page
        :columns="columns"
        :headers="headers"
        :popupComponent="popupComponent"
        :basic-data="basicData"
        sort="email"
        title="Client List"
        icon="mdi-format-list-bulleted"
        addButtonText="Client"
        stateendpoint="client.clients"
        :is-show-client="true"
        :actions="actions"
    />
  </div>
</template>
<script>
import ListPage from "../components/ListPage";
import ClientPopup from "../components/popups/ClientPopup";

export default {
  name: 'Clients',
  metaInfo: {
    title: 'zetrank.com',
    titleTemplate: 'Admin Dashboard - Clients | %s',
    meta: [
      { name: 'robots', content: 'noindex' },
      { name: 'googlebot', content: 'noindex' }
    ]
  },
  components: {
    ListPage,
    ClientPopup
  },
  data() {
    return {
      headers: [
        {
          text: 'Email',
          value: 'email'
        },
        {
          text: 'Name',
          value: 'name'
        },
        {
          text: 'Phone',
          value: 'phone'
        },
        {
          text: 'Skype',
          value: 'skype'
        },
        {
          text: 'Whatsapp',
          value: 'whatsapp'
        },
        {
          text: 'Price',
          value: 'price',
          align: 'right'
        },
        {
          text: 'Is Blocked?',
          value: 'isBlocked',
          align: 'center'
        },
        {
          text: 'Description',
          value: 'description'
        },
       /* {
          text: 'Link Price',
          value: 'linkPrice',
          align: 'right'
        },*/
        {
          text: 'Other Price',
          value: 'adultPrice',
          align: 'right'
        },
        {
          text: 'Discount(%)',
          value: 'percentageOfDiscount',
          align: 'right'
        },
        {
          text: '', value: 'actions', sortable: false
        }
      ],
      columns: [
        {value: 'email'},
        {value: 'price'},
        {value: 'action'},
      ],
      actions: {
        load: 'loadClients',
        create: 'storeClient',
        update: 'updateClient',
        remove: 'destroyClient',
        softDelete: 'removeClient'
      },
      basicData: {
        price: 0,
        linkPrice: 0,
        adultPrice: 0,
        percentageOfDiscount: 0,
        type: 2,
        isBlocked: 0,
        description: ''
      }
    }
  },
  computed: {
    popupComponent() {
      return ClientPopup;
    }
  }
}
</script>
